import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import categoryReducer from "./category/categorySlice";
import subCategoryReducer from "./subCategory/subCategorySlice";
import questionReducer from "./question/questionSlice";
import columnsReducer from "./board/columnsSlice";
import reportReducer from "./report/reportSlice";
import generaleWebDataReducer from "./generaleWebData/generaleWebDataSlice";
import userReducer from "./user/userSlice";
import lostAndFoundItemRequestSlice from "./LostAndFoundItemRequest/lostAndFoundItemRequest";
import deleteReasonReducer from "./deleteReason/deleteReasonSlice";
import shipReducer from "./ship/shipSlice";
import airportReducer from "./airport/airportSlice";
import pricingPlanReducer from "./pricingPlan/pricingPlanTypeSlice";
import featuresReducer from "./feature/featuresTypeSlice";
import establishmentTypeReducer from "./establishmentType/establishmentTypeSlice";
import establishmentTypeQuestionReducer from "./establishmentTypeQuestion/establishmentTypeQuestionSlice";
import establishmentLocationReducer from "./establishmentLocation/establishmentLocationSlice";
import placeReducer from "./place/placeSlice";
import contactReducer from "./contact/contactSlice";
import locationReducer from "./location/locationSlice";
import emailTemplateReducer from "./emailTemplate/emailTemplateSlice";
import foundReport from "../features/foundReport/foundReportSlice";
import stickyReducer from "./sticky/stickySlice";
import foundItemDiscardReasonReducer from "./foundItemDiscardReason/foundItemDiscardReasonSlice";
import activityLogReducer from "./activityLog/activityLogSlice";
import carrierReducer from "./carrier/carrierSlice";
import courierReducer from "./courier/courierSlice";
import pricingConfigurationReducer from "./pricingConfiguration/pricingConfigurationSlice";
import schedulerSettingsReducer from "./schedulerSettings/schedulerSettingsSlice";
import shipFromPortReducer from "./ShipFromPort/ShipFromPortSlice";
import logsReducer from "./logs/logsSlice";
import customerListReducer from "./customers/customerTypeSlice";
import whiteboardReducer from "./whiteboard/whiteboardSlice";
import paymentConfigurationReducer from "./paymentConfiguration/paymentConfigurationSlice";
import courierShippingOptionsReducer from "./courierShippingOptions/courierShippingOptionsSlice";
import shippingBoxTypeReducer from "./shippingBoxType/shippingBoxTypeSlice";
import languageConfigurationReducer from "./languageConfiguration/languageConfigurationSlice";
import conversionTrackingReducer from "./conversionTracking/conversionTrackingSlice";
import campaignReducer from "./campaign/campaignSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  categories: categoryReducer,
  subCategories: subCategoryReducer,
  question: questionReducer,
  deleteReason: deleteReasonReducer,
  columns: columnsReducer,
  report: reportReducer,
  generaleWebData: generaleWebDataReducer,
  users: userReducer,
  lostItemRequest: lostAndFoundItemRequestSlice,
  ships: shipReducer,
  airports: airportReducer,
  pricingPlan: pricingPlanReducer,
  features: featuresReducer,
  establishmentType: establishmentTypeReducer,
  establishmentTypeQuestion: establishmentTypeQuestionReducer,
  establishmentLocation: establishmentLocationReducer,
  place: placeReducer,
  contact: contactReducer,
  location: locationReducer,
  emailTemplate: emailTemplateReducer,
  foundReport: foundReport,
  sticky: stickyReducer,
  foundItemDiscardReason: foundItemDiscardReasonReducer,
  activityLog: activityLogReducer,
  carrier: carrierReducer,
  courier: courierReducer,
  pricingConfiguration: pricingConfigurationReducer,
  schedulerSettings: schedulerSettingsReducer,
  shipFromPort: shipFromPortReducer,
  logs: logsReducer,
  customerList: customerListReducer,
  whiteboard: whiteboardReducer,
  paymentConfiguration: paymentConfigurationReducer,
  courierShippingOptions: courierShippingOptionsReducer,
  shippingBoxType: shippingBoxTypeReducer,
  languageConfiguration: languageConfigurationReducer,
  conversionTracking: conversionTrackingReducer,
  campaign: campaignReducer,
});

export default rootReducer;
